import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation, useParams } from "react-router-dom";
import tmi from "tmi.js";

const Streams = () => {
  const params = useParams();

  const location = useLocation();

  const [loginID, setLoginID] = useState(["", "", "", ""]);

  useEffect(() => {
    if (Object.keys(params).length) {
      if (!params.id2) {
        params.id2 = "";
      }
      if (!params.id3) {
        params.id3 = "";
      }
      if (!params.id4) {
        params.id4 = "";
      }
      setLoginID([
        `${params.id1}`,
        `${params.id2}`,
        `${params.id3}`,
        `${params.id4}`,
      ]);
      localStorage.setItem("urltext_1", `${params.id1}`);
      localStorage.setItem("urltext_2", `${params.id2}`);
      localStorage.setItem("urltext_3", `${params.id3}`);
      localStorage.setItem("urltext_4", `${params.id4}`);
    } else {
      let { fst, snd, srd, fth } = location.state;
      setLoginID([fst, snd, srd, fth]);
      localStorage.setItem("urltext_1", fst);
      localStorage.setItem("urltext_2", snd);
      localStorage.setItem("urltext_3", srd);
      localStorage.setItem("urltext_4", fth);
    }
    return () => {};
  }, []);

  console.log(params);

  const [widthSize, setWidthSize] = useState(0);

  const [heightSize, setHeightSixw] = useState(0);

  const [isPlaying, setIsPlaying] = useState(true);

  const [chats, setChats] = useState([]);

  useEffect(() => {
    setWidthSize(window.innerWidth);
    setHeightSixw(window.innerHeight);
  }, []);

  useEffect(() => {
    const client = new tmi.Client({
      channels: [loginID[0]],
    });

    client.connect();

    client.on("message", (channel, tags, message, self) => {
      console.log(`${tags["display-name"]}: ${message}`);
      setChats((pre) => {
        const arry = [[`${tags["display-name"]}`, `${message}`], ...pre];
        if (arry.length > 5) {
          arry.pop();
        }
        return arry;
      });
    });

    return () => {
      client.disconnect();
    };
  }, [loginID]);

  const changeStream1 = () => {
    setLoginID((pre) => {
      return [pre[1], pre[0], pre[2], pre[3]];
    });
    setIsPlaying(false);
    setTimeout(() => {
      setIsPlaying(true);
    }, 1000);
    setChats([]);
  };

  const changeStream2 = () => {
    setLoginID((pre) => {
      return [pre[2], pre[1], pre[0], pre[3]];
    });
    setIsPlaying(false);
    setTimeout(() => {
      setIsPlaying(true);
      console.log("ok");
    }, 1000);
    setChats([]);
  };

  const changeStream3 = () => {
    setLoginID((pre) => {
      return [pre[3], pre[1], pre[2], pre[0]];
    });
    setIsPlaying(false);
    setTimeout(() => {
      setIsPlaying(true);
    }, 1000);
    setChats([]);
  };

  return (
    <>
      <div className="hidden  lg:grid lg:grid-cols-3 lg:justify-items-center ">
        <div className="grid grid-cols-1  justify-items-center">
          <div className="flex flex-col justify-between">
            <div className="">
              <ReactPlayer
                url={`https://www.twitch.tv/${loginID[1]}?lang=ja`}
                width={widthSize / 3}
                height={heightSize / 3}
                playing={true}
                volume={1}
                muted={true}
                config={{
                  twitch: {
                    options: {
                      width: "100%",
                      height: "100%",
                    },
                  },
                }}
              />
            </div>
            <div className="">
              <ReactPlayer
                url={`https://www.twitch.tv/${loginID[2]}?lang=ja`}
                width={widthSize / 3}
                height={heightSize / 3}
                playing={true}
                volume={1}
                muted={true}
                config={{
                  twitch: {
                    options: {
                      width: "100%",
                      height: "100%",
                    },
                  },
                }}
              />
            </div>
            <div className="">
              <ReactPlayer
                url={`https://www.twitch.tv/${loginID[3]}?lang=ja`}
                width={widthSize / 3}
                height={heightSize / 3}
                playing={true}
                volume={1}
                muted={true}
                config={{
                  twitch: {
                    options: {
                      width: "100%",
                      height: "100%",
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-span-2 relative">
          <ReactPlayer
            url={`https://www.twitch.tv/${loginID[0]}?lang=ja`}
            playing={true}
            volume={1}
            width={(widthSize * 2) / 3 - 1}
            height={heightSize}
            config={{
              twitch: {
                options: {
                  width: "100%",
                  height: "100%",
                },
              },
            }}
          />
          {isPlaying && (
            <div className="absolute top-0 inset-x-1/2 z-30 flex  items-center justify-center">
              <div className="flex select-none space-x-1 text-gray-700 opacity-50">
                <div
                  className="rounded-md bg-gray-200 px-4 py-2 transition duration-300 hover:bg-gray-400"
                  onClick={changeStream1}
                >
                  1
                </div>
                <div
                  className="rounded-md bg-gray-200 px-4 py-2 transition duration-300 hover:bg-gray-400"
                  onClick={changeStream2}
                >
                  2
                </div>
                <div
                  className="rounded-md bg-gray-200 px-4 py-2 transition duration-300 hover:bg-gray-400"
                  onClick={changeStream3}
                >
                  3
                </div>
              </div>
            </div>
          )}
          <div className="absolute bottom-0 left-1/4 z-30 flex  items-center justify-center opacity-50 text-white">
            <ul>
              {chats.map((chat, index) => {
                return (
                  <li key={index}>
                    <span className="text-sky-400">{chat[0]}</span>
                    <span className="text-sky-200">:</span>
                    <span>{chat[1]}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="lg:hidden grid grid-cols-1 justify-items-center">
        <div>
          <ReactPlayer
            url={`https://www.twitch.tv/${loginID[0]}?lang=ja`}
            playing={true}
            width={widthSize}
            height={heightSize / 2}
            volume={1}
            muted={true}
            config={{
              twitch: {
                options: {
                  width: "100%",
                  height: "100%",
                },
              },
            }}
          />
        </div>
        <div>
          <ReactPlayer
            url={`https://www.twitch.tv/${loginID[1]}?lang=ja`}
            playing={true}
            width={widthSize}
            height={heightSize / 2}
            volume={1}
            muted={true}
            config={{
              twitch: {
                options: {
                  width: "100%",
                  height: "100%",
                },
              },
            }}
          />
        </div>
        <div>
          <ReactPlayer
            url={`https://www.twitch.tv/${loginID[2]}?lang=ja`}
            playing={true}
            width={widthSize}
            height={heightSize / 2}
            light={true}
            config={{
              twitch: {
                options: {
                  width: "100%",
                  height: "100%",
                },
              },
            }}
          />
        </div>
        <div>
          <ReactPlayer
            url={`https://www.twitch.tv/${loginID[3]}?lang=ja`}
            playing={true}
            width={widthSize}
            height={heightSize / 2}
            light={true}
            config={{
              twitch: {
                options: {
                  width: "100%",
                  height: "100%",
                },
              },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Streams;

//https://www.twitch.tv/monstercat?lang=ja

/* */
